import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="-8 -10 36 36" { ...props }>
    <style />
    <path
      d="M27.21 26.5l-7.24-7.24C21.85 17.21 23 14.5 23 11.5 23 5.15 17.85 0 11.5 0S0 5.15 0 11.5 5.15 23 11.5 23c3 0 5.71-1.15 7.76-3.03l7.24 7.24.71-.71zM1 11.5C1 5.71 5.71 1 11.5 1S22 5.71 22 11.5 17.29 22 11.5 22 1 17.29 1 11.5z"
      fill={ fill }
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
